<script lang="ts">
  import ProjectTemplate from "../../components/project-template.svelte";

  export let error: Error;
</script>

<ProjectTemplate isEmbedded={false}>
  <div>{error.name}</div>
  <div>{error.message}</div>
</ProjectTemplate>
